/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Scheduling/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Scheduling({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Scheduling",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#49C3B4"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Scheduling.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-20Ia7X': alignSelf,'--mt-2-20Ia7X': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-20Ia7X': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-20Ia7X': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-20Ia7X': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-20Ia7X': opacity,'--w-10-20Ia7X': typeof width === 'number' ? `${width}px` : width,'--h-11-20Ia7X': typeof height === 'number' ? `${height}px` : height,'--f-12-20Ia7X': fill,'--a-7-20Ia7X': isAnimated ? animation : "none",'--sd-8-20Ia7X': isAnimated ? strokeDashoffset : 0,'--sd-9-20Ia7X': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Scheduling.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M6.5 3a1 1 0 10-2 0v1h-1A1.5 1.5 0 002 5.5v9A1.5 1.5 0 003.5 16h11a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0014.5 4h-1V3a1 1 0 10-2 0v1h-5V3zm6 7a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zM9.625 9a.625.625 0 10-1.25 0v1.25c0 .287.195.537.473.606l1 .25a.625.625 0 10.304-1.212l-.527-.132V9z"
 style={{'--f-12-20Ia7X': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}